<template>
    <div 
        class="page-menu"
        @click="toggle"
        :style="{height: show ? '100%' : 0}"
    >
        
        <div class="menu-el">
            <div class="el1" v-show="showSub" :class="{'animated slideInLeft': type, 'animated slideOutRight': !type}">
                <div
                    class="menu"
            >   
                    <div class="word">{{$t('menu.l1.t1')}}</div>
                    <ul
                        class="menu-list"
                    >
                        <router-link tag="li" to="/covid" class="covid"><span class="li-item">{{$t('menu.l1.t2')}}<span class="icon"></span></span> </router-link>
                        <router-link tag="li" to="/project"><span class="li-item">{{$t('menu.l1.t3')}} <span class="icon"></span></span> </router-link>
                        <router-link tag="li" to="/data"><span class="li-item">{{$t('menu.l1.t4')}} <span class="icon"></span></span> </router-link>
                        <router-link tag="li" to="/welmshome"><span class="li-item">{{ $t('menu.l1.t5') }} <span class="icon"></span></span></router-link>
                        <!-- <li><a href="//global.wdyedu.com/" target="_blank" class="li-item">Demos Cloud Class <span class="icon"></span></a></li> -->
                        <router-link tag="li" to="/classrooms"><span class="li-item">{{ $t('menu.l1.t6') }} <span class="icon"></span></span></router-link>
                        <router-link tag="li" to="/look"><span class="li-item">{{$t('menu.l1.t7')}} <span class="icon"></span></span></router-link>
                        <router-link tag="li" to="/solution"><span class="li-item">{{ $t('menu.l1.t8') }} <span class="icon"></span></span></router-link>
                    </ul>
                </div>
            </div>
        </div>
        <div class="menu-el">
            <!-- <transition
                name="slide"
                enter-active-class="animated slideInLeft"
                leave-active-class="animated slideOutRight"
            > -->
                <div class="el2" v-show="showSub" :class="{'animated slideInLeft': type, 'animated slideOutRight': !type}">
                    <div
                        class="menu"
                    >   
                        <div class="word">
                            <router-link to="/news">{{ $t('menu.l2.t1') }}</router-link>
                        </div>
                    </div>
                </div>
            <!-- </transition> -->
        </div>
        <div class="menu-el">
                <div class="el3" v-show="showSub" :class="{'animated slideInLeft': type, 'animated slideOutRight': !type}">
                    <div class="change-lang" v-if="show">
                            <span v-for="(item, index) in langList" :key="index"
                            :class="{'active': item.lang == $i18n.locale}"
                            class="lang-item" @click="changeLang(item)">{{item.name}}</span>
                            <span class="lang-item" @click="changeLang('zh')">中文</span>
                        </div>
                    <div
                        class="menu"
                    >   
                        <div class="word">
                            <router-link to="/aboutus">{{ $t('menu.l3.t1') }}</router-link>
                        </div>
                        <ul
                            class="menu-list"
                        >
                            <router-link tag="li" to="/aboutus"><span class="li-item">{{ $t('menu.l3.t2') }} <span class="icon"></span></span> </router-link>
                            <router-link tag="li" to="/aboutus?tabNum=1"><span class="li-item">{{ $t('menu.l3.t3') }} <span class="icon"></span></span></router-link>
                            <router-link tag="li" to="/aboutus?tabNum=2"><span class="li-item">{{ $t('menu.l3.t4') }}<span class="icon"></span></span></router-link>
                        </ul>
                    </div>
                </div>
            <!-- </transition> -->
        </div>
        
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false,
            el1Type: false,
            showSub: true,
            langList: [{
                name: 'EN',
                lang: 'en',
            }, {
                name: 'FR',
                lang: 'fr',
            }, {
                name: 'RU',
                lang: 'ru',
            }]
        };
    },
    watch: {
        type: function(newVal) {
            const that = this;
            if (newVal) {
                this.show = true;
                // that.showSub = true;
                setTimeout(function() {
                   that.showSub = true;
                }, 500)
            } else {
                setTimeout(function() {
                   that.show = false;
                }, 500)
                // this.show = false;
            }
        }
    },
    created() {
    },
    methods: {
        hide() {
            this.show = false;
            this.showSub = false;
        },
        enter() {
            this.el1Type = !this.el1Type;
        },
        toggle() {
            this.$emit('toggle');
        },
        changeLang(item) {
            if (item === 'zh') {
                window.location.href = 'https://www.wedon.com/'
            } else if (item.lang == 'ru' || item.lang == 'fr' || item.lang == 'en') {
                window.localStorage.setItem('localeLanguage', item.lang);
                if(this.$route.name == 'newsinfo') {
                     window.location.replace(`${location.origin}/news?lang=${item.lang}`)
                } else {
                    window.location.replace(`${location.origin}${location.pathname}?lang=${item.lang}`)
                }
               
               
            } else {
                location.href = location.origin;
            }

        }
    }
}
</script>
<style lang="less">

.page-menu {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    color: #fff;
    .menu {
        position: absolute;
        top: 50%;
        left: 72px;
        cursor: pointer;
        transform: translateY(-50%);
        &:hover {
            .word {
                &::before {
                    content: '';
                    position: absolute;
                    height: 2px;
                    width: 100%;
                    background: #FD8E0D;
                    bottom: 0;
                }
            }
            .menu-list {
                max-height: 500px;
                opacity: 1;
            }
        }
    }

    .animated {
        animation-duration: .5s;
    }
    // .animated.slideInLeft.slide-enter-to{
    //     animation-duration: 5s;
    // }
    // .slide-enter-active {
    //     transition: .5s!important; /* MISSING RULE */
    // }
    // .slide-leave-active,
    //     .slide-enter-active {
    //     transition: .5s!important;
    //     }
    //     .slide-enter {
    //     transform: translate3D(100%, 0, 0)!important;
    //     }
    //     .slide-leave-to {
    //     transform: translateY(-100%, 0, 0)!important;
    //     }

    .menu-list {
        max-height: 0;
        transition: all ease-in .5s;
        overflow: hidden;
        font-family: HelveticaNeue, Arial, sans-serif;
        font-size: 22px;
        color: #fff;
        opacity: 0;
        .covid {
            color: #4EAAFF;
        }
        li:first-child{
            margin-top: 70px;
        }
        li~li {
            margin-top: 30px;
        }
        li {
            padding-right: 16px;
            position: relative;
            
            .icon {
                display: inline-block;
                // display: none;
            }
            .icon-text {
                 display: inline-block;
                // display: none;
                color: #FD8E0D;
                font-size: 12px;
            }
            .li-item {
                display: inline-block;
                position: relative;
                &::before {
                    transition: all ease-in .3s;
                    content: '';
                    position: absolute;
                    height: 2px;
                    width: 0;
                    background: #ffffff;
                    bottom: -6px;
                }
            }
            
            &:hover{
                .li-item {
                    &::before {
                        content: '';
                        position: absolute;
                        height: 2px;
                        width: 100%;
                        background: #FD8E0D;
                    }
                }
                
                .icon {
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-left: 8px #FD8E0D solid;
                    border-bottom: 6px solid transparent;
                }
                .icon-text {
                    display: inline-block;
                    color: #FD8E0D;
                    font-size: 12px;
                }
                
            }
        }
    }

    .word {
        font-size: 36px;
        font-weight: bold;
        position: relative;
        display: inline-block;
        padding-bottom: 7px;
        &::before {
            transition: all ease-in .3s;
            content: '';
            position: absolute;
            height: 2px;
            width: 0;
            background: #ffffff;
            bottom: 0;
        }
    }
}

.menu-el {
    flex: 1;
    position: relative;
    display: inline-block;
    height: 100%;
    overflow: hidden;
}
.change-lang {
    position: absolute;
    top: 40px;
    right: 130px;
    z-index: 1;
    height: 50px;
    line-height: 50px;
    .lang-item {
        position: relative;
        display: inline-block;
        width: 50px;
        text-align: center;
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        &.active {
            color: #fff;
        }

    }
    .lang-item ~ .lang-item {
        &:before {
            width: 1px;
            content: '';
            height: 6px;
            position: absolute;
            top: 23px;
            left: 0px;
            background: rgba(255, 255, 255, 0.6);
        }

    }
}


.el1, .el2, .el3 {
    height: 100%;
    width: 100%;
    animation-timing-function: ease-in;
    a {
        color: #fff;
        text-decoration: none;
    }
}
.el1 {
    background: #313BA9;
    .menu-list li ~ li {
        margin-top: 18px;
    }
    .menu-list li:first-child {
        margin-top: 35px;
    }
    li {
        height: 36px;
    }
    .menu {
        left: 40px;
    }
}

.el2 {
    background: #232C92;
}

.el3 {
    background: #192184;
    .menu-list li {
        height: 36px;
    }
}
</style>